/**
 * Layout dimension constants for sticky headers and scroll behavior.
 */

/** Global app header height in pixels */
export const HEADER_HEIGHT = 72;

/** Section navigation bar height in pixels */
export const SECTION_NAV_HEIGHT = 48;

/** Extra breathing room when scrolling to sections in pixels */
export const SCROLL_PADDING = 16;
